module.exports = __webpack_public_path__ + "img/ic_point_add.f80a0a98.svg";